import * as yup from 'common/yup';

/*{
   "lastUser": "string",
   "timestamp": 0,
   "id": "7458847157560353699875108830585328714444298",
   "objectType": "ARCHIVE_SETTINGS",
   "name": "string",
   "folderId": "string",
   "suspended": true,
   "enabled": true,
   "blockKnownAttacker": true,
   "blockKnownSpam": true,
   "blockBogon": true,
   "blockTor": true,
   "blockVPN": true,
   "blockProxy": true,
   "blockDataCenter": true,
   "useThreatThreshold": true,
   "threatThreshold": 0,
   "useTrustThreshold": true,
   "trustThreshold": 0
 }*/

export const ThreatIntelligenceSettingsNames = {
   enabled: 'enabled',
   blockKnownAttacker: 'blockKnownAttacker',
   blockKnownSpam: 'blockKnownSpam',
   blockTor: 'blockTor',
   blockVPN: 'blockVPN',
   blockProxy: 'blockProxy',
   blockDataCenter: 'blockDataCenter',
   useThreatThreshold: 'useThreatThreshold',
   threatThreshold: 'threatThreshold',
   useTrustThreshold: 'useTrustThreshold',
   trustThreshold: 'trustThreshold',
   // TODO blockBogon
} as const;

export const ThreatIntelligenceSettings = yup.object({
   [ThreatIntelligenceSettingsNames.enabled]: yup.boolean().defined(),
   [ThreatIntelligenceSettingsNames.blockKnownAttacker]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.blockKnownSpam]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.blockTor]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.blockVPN]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.blockProxy]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.blockDataCenter]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.useThreatThreshold]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.threatThreshold]: yup
      .number()
      .min(0, 'Must be >= 0')
      .max(100, 'Must be <= 100'),
   [ThreatIntelligenceSettingsNames.useTrustThreshold]: yup.boolean(),
   [ThreatIntelligenceSettingsNames.trustThreshold]: yup
      .number()
      .min(0, 'Must be >= 0')
      .max(100, 'Must be <= 100'),
});

export type IThreatIntelligenceSettings = yup.InferType<typeof ThreatIntelligenceSettings>;
